import { render, staticRenderFns } from "./projects-table.vue?vue&type=template&id=2bb79c0c&scoped=true"
import script from "./projects-table.vue?vue&type=script&lang=js"
export * from "./projects-table.vue?vue&type=script&lang=js"
import style0 from "./projects-table.vue?vue&type=style&index=0&id=2bb79c0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb79c0c",
  null
  
)

export default component.exports